import { render, staticRenderFns } from "./MenuUK.vue?vue&type=template&id=6b7eb4bd&scoped=true&"
import script from "./MenuUK.vue?vue&type=script&lang=js&"
export * from "./MenuUK.vue?vue&type=script&lang=js&"
import style0 from "./MenuUK.vue?vue&type=style&index=0&id=6b7eb4bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7eb4bd",
  null
  
)

export default component.exports